import * as THREE from 'three';
import gsap from 'gsap';
import { scene, group } from './Scene';

export const SetupLights = () => {
    const light = new THREE.DirectionalLight(0xffffff, 0.5);
    light.position.set(0.1, 1, 0.3);
    light.castShadow = true;
    light.shadow.mapSize.width = 4096;
    light.shadow.mapSize.height = 4096;
    light.shadow.camera.left = light.shadow.camera.bottom = -2;
    light.shadow.camera.right = light.shadow.camera.top = 2;
    light.shadow.radius = 0.2;
    // light.shadow.bias = -0.0001;
    light.shadow.intensity = 1;
    light.shadow.near = 0.01;
    light.shadow.far = 5;
    scene.add(light);

    // const lightHelper = new THREE.DirectionalLightHelper(light);
    // scene.add(lightHelper);

    // const lightShadow = new THREE.CameraHelper(light.shadow.camera);
    // scene.add(lightShadow);

    const ambientLight = new THREE.AmbientLight(0x0055aa);
    scene.add(ambientLight);
    return { light, ambientLight };
};

export const SetupPointLight = (
    _obj = null,
    _pos,
    _color,
    _intencity = 1,
    _distance = 1,
    _decay = 2) => {
    // console.log('set point light');
    const pointLight = new THREE.PointLight(_color, _intencity, _distance, _decay);
    pointLight.castShadow = true;
    group.add(pointLight);
    pointLight.name = 'point light'
    pointLight.rotation.set(0, Math.PI / 2, 0)
    if (_obj !== null)
        pointLight.position.copy({ x: _obj.position.x, y: _obj.position.y, z: _obj.position.z });
    else pointLight.position.copy(_pos);
    // console.log(pointLight.position);

    // const pointLightHelper = new THREE.PointLightHelper(pointLight, _distance);
    // group.add(pointLightHelper);
    return pointLight;
}

//#region 공통
let signBoardLight;
export const SetSignBoardLight = (_index) => {
    for (var i = 1; i < 8; i++) {
        const signBoardPanel = group.getObjectByName(`sb_wh${i}`);
        const signBoardLight = group.getObjectByName(`sb_light${i}`)
        const signBoardIcon = group.getObjectByName(`sb_icon${i}`);

        gsap.killTweensOf(signBoardPanel.material);
        gsap.killTweensOf(signBoardLight.material);

        if (i === _index) {
            signBoardPanel.material.emissive = new THREE.Color().setHex(0x22AAFF);
            signBoardPanel.material.emissiveIntensity = 0;

            gsap.to(signBoardPanel.material, {
                emissiveIntensity: 2,
                duration: 0.3,
            });

            gsap.to(signBoardLight.material, {
                opacity: 0.5,
                duration: 0.3,
            });
        }
        else {
            signBoardPanel.material.emissive = new THREE.Color().setHex(0x22AAFF);

            gsap.to(signBoardPanel.material, {
                emissiveIntensity: 0,
                duration: 0.3,
            });
            gsap.to(signBoardLight.material, {
                opacity: 0,
                duration: 0.3,
            })
        }
    }
}

//#endregion

//#region 01 자판기
export const SetCoinInsertLight = (isOn) => {
    const coinInsert = scene.getObjectByName('s01_coin');
    if (isOn) {
        if (coinInsert) {
            coinInsert.material.emissive = new THREE.Color().setHex(0xffffff);
            coinInsert.material.emissiveIntensity = 0;
            gsap.killTweensOf(coinInsert.material);
            gsap.to(coinInsert.material, {
                emissiveIntensity: 0.5,
                duration: 1,
                repeat: -1,
                yoyo: true
            });
        }
    }
    else {
        if (coinInsert) {
            gsap.killTweensOf(coinInsert.material);
            gsap.to(coinInsert.material, {
                emissiveIntensity: 0,
                duration: 0.2,
            });
        }
    }
}

let buttonLight;
export const SetButtonLight = (isOn) => {
    // - 자판기 버튼에 라이트 들어온다.
    const machineButton = scene.getObjectByName('s01_button');
    if (isOn) {
        if (machineButton) {
            machineButton.material.emissive = new THREE.Color().setHex(0x0000ff);
            machineButton.material.emissiveIntensity = 0;
            gsap.to(machineButton.material, {
                emissiveIntensity: 8,
                duration: 1,
                repeat: -1,
                yoyo: true
            });
        }
        buttonLight = SetupPointLight(null, { x: -0.23, y: 0.052, z: 0.23 }, 0x0000ff, 0, 0.1, 1);
        gsap.to(buttonLight, {
            intensity: 0.3,
            duration: 1,
            repeat: -1,
            yoyo: true
        })
    }

    else {
        if (buttonLight) {
            gsap.to(buttonLight, {
                intensity: 0,
                duration: 0.5,
                onComplete: () => {
                    group.remove(buttonLight);
                    buttonLight.dispose();
                    buttonLight = null;
                }
            })
        }
        if (machineButton) {
            gsap.killTweensOf(machineButton.material);
            gsap.to(machineButton.material, {
                emissiveIntensity: 0,
                duration: 0.5,
            });
        }
    }
}

//#endregion

//#region s02 전구
let bulbLight;
export const SetBulbLight = (isOn) => {
    const coil = scene.getObjectByName('s02_coil');
    if (isOn) {
        if (coil) {
            coil.material.emissive = new THREE.Color().setHex(0xff8800);
            coil.material.emissiveIntensity = 0; // 초기값 설정

            gsap.to(coil.material, {
                emissiveIntensity: 10,
                duration: 2
            });
        }

        bulbLight = SetupPointLight(null, { x: -0.06, y: 0.18, z: 0.27 }, 0xff8800, 0, 0.5, 1.2);
        const blinkTimeline = gsap.timeline();

        // 불규칙한 깜빡임 효과 추가
        blinkTimeline
            .to(bulbLight, { intensity: 0.2, duration: 0.1 })
            .to(bulbLight, { intensity: 0.7, duration: 0.15 })
            .to(bulbLight, { intensity: 0.3, duration: 0.1 })
            .to(bulbLight, { intensity: 0.8, duration: 0.2 })
            .to(bulbLight, { intensity: 0.4, duration: 0.1 })
            .to(bulbLight, { intensity: 0.9, duration: 0.12 })
            .to(bulbLight, { intensity: 0.5, duration: 0.1 })
            .to(bulbLight, { intensity: 1, duration: 0.5 })
    }
    else {
        if (coil) {
            gsap.to(coil.material, {
                emissiveIntensity: 0,
                duration: 2
            });
        }
        if (bulbLight) {
            gsap.to(bulbLight, {
                intensity: 0,
                duration: 2,
                onComplete: () => {
                    group.remove(bulbLight);
                    bulbLight.dispose();
                    bulbLight = null;
                }
            });
        }
    }
}
//#endregion

//#region s07 색칠
export const SetColorButtonLight = (isOn) => {
    const buttons = [];
    const redButton = scene.getObjectByName('s07_button_red');
    const greenButton = scene.getObjectByName('s07_button_green');
    const blueButton = scene.getObjectByName('s07_button_blue');
    buttons.push(redButton);
    buttons.push(greenButton);
    buttons.push(blueButton);



    if (isOn) {
        buttons.forEach(child => {
            if (child) {
                child.material.emissive = new THREE.Color().setHex(0xffffff);
                child.material.emissiveIntensity = 0;
                gsap.killTweensOf(child.material);
                gsap.to(child.material, {
                    emissiveIntensity: 0.5,
                    duration: 1,
                    repeat: 4,
                    yoyo: true
                });
            }
        });
    }
    else {
        buttons.forEach(child => {
            if (child) {
                gsap.killTweensOf(child.material);
                gsap.to(child.material, {
                    emissiveIntensity: 0,
                    duration: 0.2,
                });
            }
        });
    }
}

export const SetLeverLight = (isOn) => {
    const lever = [];
    const leverBody = scene.getObjectByName('s07_leverbody');
    const leverStick = scene.getObjectByName('s07_lever');

    lever.push(leverBody);
    lever.push(leverStick);
    if (isOn) {
        lever.forEach(child => {
            if (child) {
                child.material.emissive = new THREE.Color().setHex(0xffffff);
                child.material.emissiveIntensity = 0;
                gsap.killTweensOf(child.material);
                gsap.to(child.material, {
                    emissiveIntensity: 0.5,
                    duration: 1,
                    repeat: 4,
                    yoyo: true
                });
            }
        });
    }
    else {
        lever.forEach(child => {
            if (child) {
                gsap.killTweensOf(child.material);
                gsap.to(child.material, {
                    emissiveIntensity: 0,
                    duration: 0.2,
                });
            }
        });
    }
}

//#endregion

//#region s09 패턴기계
let machineLight;
export const SetPatternMachineLight = (isOn, color = new THREE.Color().setHex(0xffff00)) => {
    const light = scene.getObjectByName('s09_light');

    if (isOn) {
        machineLight = SetupPointLight(null, { x: -0.01, y: 0.235, z: 0.115 }, color, 0, 0.1, 1);

        gsap.to(machineLight, {
            intensity: 0.5,
            duration: 0.1,
            repeat: 7,
            yoyo: true,
            onComplete: () => {
                SetPatternMachineLight(false);
            }
        });

        gsap.killTweensOf(light.material);
        gsap.to(light.material, {
            opacity: 0.3,
            duration: 0.1,
            repeat: 7,
            yoyo: true
        });
    } else {
        if (machineLight) {
            gsap.killTweensOf(machineLight);
            gsap.to(machineLight, {
                intensity: 0,
                duration: 0.1,
                onComplete: () => {
                    group.remove(machineLight);
                    machineLight.dispose();
                    machineLight = null;
                }
            });
        }
        gsap.killTweensOf(light.material);
        gsap.to(light.material, {
            opacity: 0,
            duration: 0.1
        })
    }
}
//#endregion

//#region s10 미끄럼틀
let sirenLight;
export const SetSirenLight = (isOn) => {
    const siren = scene.getObjectByName('s10_siren');

    if (isOn) {
        sirenLight = SetupPointLight(null, { x: -0.26, y: 0.15, z: 0.05 }, 0xff0000, 0, 0.25, 1);

        gsap.to(sirenLight, {
            intensity: 0.5,
            duration: 0.8,
            repeat: -1,
            yoyo: true,
            ease: 'power2.inOut',
            // onComplete: () => {
            //     SetSirenLight(false);
            // }
        })

        siren.material.emissive = new THREE.Color().setHex(0xff0000);
        siren.material.emissiveIntensity = 0;
        gsap.killTweensOf(siren.material);
        gsap.to(siren.material, {
            emissiveIntensity: 0.5,
            duration: 0.8,
            repeat: -1,
            yoyo: true
        });
    }
    else {
        if (sirenLight) {
            gsap.killTweensOf(sirenLight);
            gsap.to(sirenLight, {
                intensity: 0,
                duration: 2,
                onComplete: () => {
                    group.remove(sirenLight);
                    sirenLight.dispose();
                    sirenLight = null;
                }
            });
        }
        gsap.killTweensOf(siren.material);
        gsap.to(siren.material, {
            emissiveIntensity: 0,
            duration: 2,
        });
    }
}

export const SetGaugeLight = (_power) => {
    const gauges = [...group.getObjectByName('s10_gauge').children]
        .slice(0, 5) // 앞에서 5개만 선택
        .reverse();  // 뒤집기

    for (var i = 0; i < gauges.length; i++) {
        if (i < _power) {
            gauges[i].material.emissive = new THREE.Color().setHex(0xff0000);
            gauges[i].material.emissiveIntensity = 1;
        }
        else {
            gauges[i].material.emissive = new THREE.Color().setHex(0xff0000);
            gauges[i].material.emissiveIntensity = 0;
        }
    }
}
//#endregion

//#region final
let spotLight;
export const SetSpotLight = (isOn) => {
    const endLight = scene.getObjectByName('end_light');

    if (isOn) {
        spotLight = new THREE.SpotLight(0xffff00);
        spotLight.position.set(0, 0, 0);

        // ✅ 타겟 오브젝트를 위쪽으로 설정 (예: y = 1)
        const targetObject = new THREE.Object3D();
        targetObject.position.set(0, 1, 0); // 위 방향
        group.add(targetObject); // 씬에 추가
        spotLight.target = targetObject;

        spotLight.intensity = 0;
        spotLight.angle = Math.PI / 18; // 약 10도 각도

        group.add(spotLight);

        gsap.to(spotLight, {
            intensity: 1,
            duration: 5,
            // ease: 'power2.inOut',
            ease: 'linear'
        })
        // const spotLightHelper = new THREE.SpotLightHelper(spotLight);
        // group.add(spotLightHelper)
        gsap.killTweensOf(endLight.material);
        gsap.to(endLight.material, {
            opacity: 0.3,
            duration: 5
        });
    }
    else {
        if (spotLight) {
            gsap.killTweensOf(spotLight);
            gsap.to(spotLight, {
                intensity: 0,
                duration: 2,
                onComplete: () => {
                    group.remove(spotLight);
                    spotLight.dispose();
                    spotLight = null;
                }
            });
        }
        gsap.killTweensOf(endLight.material);
        gsap.to(endLight.material, {
            opacity: 0,
            duration: 2,
        });
    }
}
//#endregion